module.exports = __webpack_public_path__ + "static/img/404.1af0fe7a.gif";